import type { AppServer } from '@ms-cloudpack/app-server';

/**
 * Dispose an app/API/bundle server with logging and error handling.
 */
export async function disposeServer(name: string, server: Pick<AppServer, 'url' | 'close'> | undefined): Promise<void> {
  if (!server) return;

  const desc = `${name} (${server.url})`;
  console.info(`Closing ${desc}`);
  try {
    await server.close();
    console.info(`Closed ${desc}`);
  } catch (err) {
    console.warn(`Error closing ${desc}:`, err);
  }
}
